<template>
    <v-layout>         
        <!-- Apply for Mobile -->
        <v-container v-if="isMobile">
            <v20a6000m :route-name="$route.name+'m'"></v20a6000m>
        </v-container>
        <!-- Apply for PC or Laptop -->
        <v-container v-else>
            <v20a6000pc :route-name="$route.name+'pc'"></v20a6000pc>
        </v-container> 
    </v-layout>    
</template>

<script>

import v20a6000m from './popup/v20a6000m'
import v20a6000pc from './popup/v20a6000pc'


export default {
    
    name: "v20a6000",
    components: {
       v20a6000m,
       v20a6000pc 
    },
    props:{
       
    },
    data: () => ({  
        // isHidden: false
    }),   
    
    computed: {       

        isMobile() {
            return this.$vuetify.breakpoint.smAndDown; // Kiểm tra nếu là mobile
        },
        screenSize() {
            return this.$vuetify.breakpoint.name; // Lấy tên breakpoint hiện tại
        }
    },

    watch: {
        isMobile(newValue) {
        // console.log("🔄 Chuyển sang:", newValue ? "Mobile" : "Desktop");
        }
    },

    mounted() {

        

     
    },
    methods : {

    }

    
}
</script>